import { render, staticRenderFns } from "./icon-colored-cross.vue?vue&type=template&id=917161e4&"
import script from "./icon-colored-cross.vue?vue&type=script&lang=js&"
export * from "./icon-colored-cross.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports